<template lang="pug">
  sweet-modal(ref="email" title="Отправить Email" v-on:close="resetForm")
    .email-modal
      ValidationObserver(v-slot="{ invalid }" ref="form")
        .form-group
          .form-row
            ValidationProvider(
              name="topic"
              rules="notemptyTopic"
              v-slot="{ errors }"
            )
              input#topic(
                type="text"
                placeholder="Тема письма"
                name="topic"
                v-model="topic"
                :disabled="options.disableTopic"
              ).email-modal__topic
              span {{ errors[0] }}
        .form-group
          .form-row
            ValidationProvider(
              name="message"
              rules="notemptyMessage"
              v-slot="{ errors }"
            )
              textarea#message(
                name="message"
                placeholder="Текст письма"
                v-model="message"
                :disabled="options.disableMessage"
              )
              span {{ errors[0] }}
        button.btn(
          v-promise-btn
          @click="sendEmail"
          :disabled="invalid"
        ) Отправить письмо

</template>

<script>
import apiClient from '@/apiClient';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

// Validation rules
extend('notemptyTopic', {
  ...required,
  message: 'Укажите тему письма'
});

extend('notemptyMessage', {
  ...required,
  message: 'Напишите текст письма'
});

export default {
  name: 'EmailModal',

  props: {
    clientId: {
      required: false,
      default: () => false,
      type: [Number, Boolean]
    }
  },

  data() {
    return {
      to: '',
      topic: '',
      message: '',
      options: {
        disableTopic: false,
        disableMessage: false
      }
    };
  },

  methods: {
    open() {
      this.initForm(...arguments);
      this.$refs.email.open();
    },

    initForm(to, topic, message, options) {
      this.to = to;
      this.topic = topic;
      this.message = message;
      this.options.disableTopic =
        options.disableTopic !== undefined ? options.disableTopic : false;
      this.options.disableMessage =
        options.disableMessage !== undefined ? options.disableMessage : false;
    },

    updateForm() {
      this.topic = this.options.disableTopic ? this.topic : '';
      this.message = this.options.disableMessage ? this.message : '';
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    resetForm() {
      this.to = '';
      this.topic = '';
      this.message = '';
      this.options = {
        disableTopic: false,
        disableMessage: false
      };
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    sendEmail() {
      if (this.clientId !== false) {
        return new Promise((resolve, reject) => {
          apiClient
            .post(`/notifications/clients/${this.clientId}`, {
              subject: this.topic,
              body: this.message
            })
            .then(response => {
              this.flashSuccess('Email успешно отправлен');
              this.updateForm();
              this.$refs.email.close();
              resolve(response);
            })
            .catch(err => {
              this.flashError('Возникла ошибка. Не удалось отправить email');
              reject(err);
            });
        });
      } else {
        this.flashError('Возникла ошибка. Не удалось отправить email');
        return false;
      }
    }
  },

  deactivated() {
    console.log('close');
  }
};
</script>

<style lang="scss" scoped>
.form-row {
  width: 100%;

  textarea {
    min-height: 180px;
  }
}
</style>
